export enum FeatureExposureType {
  riskAssessment = 'riskAssessment',
  testingPlan = 'testingPlan',
  actionPlan = 'actionPlan',
}
